export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-axis/src/array.js
// module id = ../../../../d3-axis/src/array.js
// module chunks = vendor